<template>
  <div id="sponsors">
    <div class="container">
      <SponsorsComponent />
    </div>
  </div>
</template>

<script>
import SponsorsComponent from "../components/event/Sponsors.vue";
import $ from "jquery"
export default {
  name: "Sponsors",
  components: { SponsorsComponent },
  methods: {},
  mounted() {
      $('html, body').animate({ scrollTop: 0 }, 350);
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
  }
};
</script>

<style lang="less">
#sponsors {
  background-color: #F1F3F6;
  min-height: calc(~"100vh");
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 20px;

  .container {
    display: block;
    max-width: 1120px;
    width: inherit;
    margin: 0 auto;
    margin-bottom: 40px;
  }
}

@media (max-width: 768px) {
  #sponsors {
    padding: 0px;
    padding-bottom: 60px;
    .container {
      padding: 0px 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Sponsors.vue